var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTableAG',{attrs:{"columns":_vm.columns,"getcontentpath":_vm.getnotificationspath,"jsonobject":"notificationsextra","buttonList":['Muokkaa'],"width":"700px","height":"750px","archivecontentpath":"2.0/newbe/deletenotifications","archiveparam":"notificationids"},on:{"pressed-button1":_vm.editNotification}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }